$(document).ready(function () {

  var urlParams = new URLSearchParams(window.location.search);
  var name = urlParams.get("name");
  var color = urlParams.get("color");
  var style = urlParams.get('style');
  var location = urlParams.get('location');
  var sfspop = urlParams.get('sfspop');
  var product = null;
  var cart = [];
  var gatesConfig = [];
  var productFormData = {
    location: null,
    name: null,
    style: null,
    color: null,
  };
  var oldDrawingData = null;
  var woodGateSizes = 0;
  var drawing_image;
  var sent_drawing_to_cart = 'false';

  // Clear all sessionStorage data, as this request is coming from Shop By Fence Style
  if (sfspop === "true") {
    sessionStorage.clear();
    openDrawingTool();
  }

  // -------- BRANCH LOCATION SESSION ------------
  // let getLocation = sessionStorage.getItem('sessionLocation');

  // if (getLocation === "Rochester, MN") {
  //   CONFIG = CONFIG_ROC;
  // }   
  // ---------------------------------------

  if (typeof (Storage) !== "undefined") {
    oldDrawingData = sessionStorage.getItem('drawingData');
    if (oldDrawingData) {
      oldDrawingData = JSON.parse(oldDrawingData);
    }
  }

  // send user to edit workflow based off of old drawing data
  if (urlParams.has('edit-drawing') && oldDrawingData && !name) {
    window.location.search = "?edit-drawing=true&name=" + oldDrawingData.name + "&style=" + oldDrawingData.style + "&color=" + oldDrawingData.color + "&location=" + oldDrawingData.location;
  }

  // change calculate button text if change type
  if (urlParams.has('change-type') && oldDrawingData) {
    // assinging the drawing image link when changing the fence type
    drawing_image = oldDrawingData.drawing_image;
    $('#typeFormSubmit').html('RECALCULATE');
  }

  function setProduct() {
    switch (style) {
      // case "vinyl":
      //   if (color == "null") {
      //     color = "White";
      //   }
      //   CONFIG.forEach(function (val) {
      //     if (val.Color === color && val.Name === name) {
      //       product = val;
      //       console.log("product color test = " + product.color);
      //     }
      //   });
      //   break;
      case "wood":
        var tmp = null;
        var colorFound = false;
        CONFIG.forEach(function (val) {
          if (val.Color === color && val.Name === name) {
            product = val;
            colorFound = true;
          }
          if (val.Name === name) {
            tmp = val;
          }

        });
        if (!colorFound) {
          product = tmp;
        }
        break;
      default:
        CONFIG.forEach(function (val) {
          if (val.Name === name) {
            product = val;
          }
        });
        break;
    }
  }

  function setGateConfig() {
    switch (style) {
      case "chain-link":
        console.log(name);
        gatesConfig = CHAIN_LINK_OPENINGS[name];
        break;
      case "commercial-chain-link":
        gatesConfig = CHAIN_LINK_OPENINGS[name];
        break;
      case "ornamental-iron":
        gatesConfig = OI_OPENINGS[name];
        break;
      case "vinyl":
        gatesConfig = VINYL_OPENINGS[name];
        break;
      // var _name = parseInt(name.charAt(0));
      // if (_name <= 0) {
      //   break;
      // }
      // if (!color) {
      //   break;
      // }
      // var _color = color.toLowerCase();
      // gatesConfig = VINYL_OPENINGS[_name + "-" + _color];
      // break;
    }
  }

  setProduct();
  setGateConfig();

  // console.log(getLocation);
  console.log(name);
  console.log(color);
  console.log(style);
  console.log(product);

  $("#spinner").hide();
  $("#main-content").fadeIn(500);

  if (!product) {
    if (typeof (Storage) !== "undefined") {
      sessionStorage.setItem("calculator", "");
    }
    window.localStorage.setItem("step", "0");
    //$("#notAvailable").show();
    //$("#main-calculator").hide();
    var formTypes = [];
    var selectedLocation = "";
    var selectedType = "";
    var selectedStyle = "";
    var selectedHeight = "";
    var selectedColor = "";

    // -------- Add the shipping/ pickup locations to choose from on form  -----------
    // var formLocation = [];
    // formLocation.push({ id: 'National / La Vista, NE', text: 'National / La Vista, NE' });
    // formLocation.push({ id: 'Rochester, MN', text: 'Rochester, MN' });

    // build location dropdown
    // $("#form-location").select2({
    //   data: formLocation,
    //   placeholder: "Select Pickup/ Shipping Location",
    //   allowClear: true,
    //   width: "300px"
    // });

    // when location is selected
    // $('#form-location').on('select2:select', function (e) {
    //   var data = e.params.data;
    //   selectedLocation = $("#form-location").val();
    //   selectedType = "";
    //   selectedStyle = "";
    //   selectedHeight = "";
    //   selectedColor = "";
    //   productFormData.location = $("#form-location").val();
    //   console.log(selectedLocation);

    //   // $('#form-type').empty();
    //   // $('#form-type').append(new Option("", "", false, false));

    //   $('#form-style').empty();
    //   $('#form-style').append(new Option("", "", false, false));

    //   $('#form-height').empty();
    //   $('#form-height').append(new Option("", "", false, false));

    //   $('#form-color').empty();
    //   $('#form-color').append(new Option("", "", false, false));

    //   // Object.keys(CALCULATOR_FORM).forEach(function (val) {
    //   //   formTypes.push({ id: val, text: val });
    //   // });

    //   sessionStorage.setItem('sessionLocation', $("#form-location").val());

    // });    

    Object.keys(CALCULATOR_FORM).forEach(function (val) {
      formTypes.push({ id: val, text: val });
    });
    $("#form-type").select2({
      data: formTypes,
      placeholder: "Select a type",
      allowClear: true,
      width: "300px"
    });
    $('#form-type').on('select2:select', function (e) {
      var data = e.params.data;
      selectedType = data.id;
      selectedStyle = "";
      selectedHeight = "";
      selectedColor = "";
      productFormData.style = data.id;

      $('#form-style').empty();
      $('#form-style').append(new Option("", "", false, false));

      $('#form-height').empty();
      $('#form-height').append(new Option("", "", false, false));

      $('#form-color').empty();
      $('#form-color').append(new Option("", "", false, false));

      Object.keys(CALCULATOR_FORM[data.id]).forEach(function (val) {
        $('#form-style').append(new Option(val, val, false, false));
      });
    });

    $("#form-style").select2({
      placeholder: "Select a style",
      allowClear: true,
      width: "300px"
    });
    $('#form-style').on('select2:select', function (e) {
      var data = e.params.data;
      selectedStyle = data.id;
      selectedHeight = "";
      selectedColor = "";

      $('#form-height').empty();
      $('#form-height').append(new Option("", "", false, false));

      $('#form-color').empty();
      $('#form-color').append(new Option("", "", false, false));

      Object.keys(CALCULATOR_FORM[selectedType][selectedStyle]).forEach(function (val) {
        $('#form-height').append(new Option(val, val, false, false));
      });
    });

    $("#form-height").select2({
      placeholder: "Select a height",
      allowClear: true,
      width: "300px"
    });
    $('#form-height').on('select2:select', function (e) {
      var data = e.params.data;
      selectedHeight = data.id;

      $('#form-color').empty();
      $('#form-color').append(new Option("", "", false, false));

      var isEmpty = false;
      var numberColorOptions = Object.keys(CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight]).length;
      Object.keys(CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight]).forEach(function (val) {
        if (numberColorOptions == 1) {
          console.log(val);
          $('#form-color').empty();
          $('#form-color').append(new Option(val, val, false, false));
          $('#form-color').attr('required', false);
          console.log(productFormData.name);
          productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight][val];
          console.log(productFormData.name);
        }
        else {
          if (val == "") {
            isEmpty = true;
            $('#form-color').empty();
            $('#form-color').append(new Option("No Color", "1", false, false));
            $('#form-color').attr('required', false);
            productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight][""];
            console.log(productFormData.name);
          }
          // else if (val == "Black") {
          //   console.log('black');
          //   $('#form-color').empty();
          //   $('#form-color').append(new Option(val, val, false, false));
          //   $('#form-color').attr('required', false);
          //   console.log(productFormData.name);
          //   productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight]["Black"];
          //   console.log(productFormData.name);
          // }
          // else if (val == "Galvanized") {
          //   console.log('Galvanized');
          //   $('#form-color').empty();
          //   $('#form-color').append(new Option(val, val, false, false));
          //   $('#form-color').attr('required', false);
          //   console.log(productFormData.name);
          //   productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight]["Galvanized"];
          //   console.log(productFormData.name);
          // }
          else if (val == "Cedar") {
            console.log('Cedar');
            $('#form-color').empty();
            $('#form-color').append(new Option(val, val, false, false));
            $('#form-color').attr('required', false);
            console.log(productFormData.name);
            productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight]["Cedar"];
            console.log(productFormData.name);
          }
          else {
            console.log('color unknown');
            $('#form-color').append(new Option(val, val, false, false));
            $('#form-color').attr('required', true);
            console.log(productFormData.name);
          }

        }

      });
    });

    $("#form-color").select2({
      placeholder: "Select a color",
      allowClear: true,
      width: "300px"
    });
    $('#form-color').on('select2:select', function (e) {
      var data = e.params.data;
      productFormData.name = CALCULATOR_FORM[selectedType][selectedStyle][selectedHeight][data.id];
      productFormData.color = data.id;
    });

    $("#formCalculate").submit(function (e) {
      e.preventDefault();
      console.log(productFormData.style);
      console.log(selectedStyle);
      // if (productFormData.style == "Chain Link") {
      //   productFormData.style = "chain-link";
      //   //productFormData.color = "null";
      // }      
      if (productFormData.style == "Chain Link - Galvanized" || productFormData.style == "Chain Link - Black") {
        if (selectedStyle == "Residential") {
          productFormData.style = "chain-link";
        }
        else {
          productFormData.style = "commercial-chain-link";
        }
        //productFormData.color = "null";
      }
      if (productFormData.style == "Ornamental" || productFormData.style == "Ornamental - Steel" || productFormData.style == "Ornamental - Aluminum") {
        productFormData.style = "ornamental-iron";
      }

      if (urlParams.has('change-type') && oldDrawingData) {
        location = productFormData.location;
        name = productFormData.name;
        style = productFormData.style.toLowerCase();
        color = productFormData.color;
        setProduct();
        setGateConfig();
        calculateDrawingTool(oldDrawingData.inventory, oldDrawingData.rawData);
      }
      else {
        // this code allows the DMF to popup from the DMF home page. This removes that extra step of the DMF second page.
        location = productFormData.location;
        name = productFormData.name;
        style = productFormData.style.toLowerCase();
        color = productFormData.color;
        setProduct();
        setGateConfig();
        openDrawingTool(productFormData);
        // end code block

        // redirects to page 2 in the background where the event listeners are that will populate the shopping cart
        setTimeout(function () {
          window.location.search = "?name=" + productFormData.name + "&style=" + productFormData.style.toLowerCase() + "&color=" + productFormData.color + "&location=" + productFormData.location;
        }, 1000);
      }
      return true;
    });
    return;
  }

  // drawing tool functionality
  var dtWindow = null;
  function openDrawingTool(data) {
    var windowName = window.location.href;
    //console.log(dtWindow);
    if (dtWindow && !dtWindow.closed) {
      dtWindow.focus();
    }
    else {
      // Updated Drawing Tool Edit
      // New subdomain (drawingtool.americafence.com). The old afpw.americafence.com/drawing-tool/ path serves the
      // legacy tool (no Shopify picker / no product return).
      var urlBase = 'https://drawingtool.americafence.com/';
      //urlBase = 'https://afpw.americafence.com/drawing-tool/'; // legacy tool — do not use
      //urlBase = 'http://localhost:8080';
      dtWindow = window.open(urlBase + '?_mode=shopify', windowName, 'height=900,width=1400,top=0,left=0,resizable=0');
    }
    // listen to drawing tool ready event
    const onReadyMessage = event => {
      if (event.data && event.data.type === 'ready') {

        const branchDetails = {
          type: 'branch-details',
          logo: 'https://cdn.shopify.com/s/files/1/0634/9556/9481/files/pro_center_logo.png?v=1789583696',
          footer: [
            // {
            //     title: 'Home',
            //     url: 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png'
            // },
            // {
            //     title: 'Test',
            //     url: 'https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png'
            // }
          ]
        }
        dtWindow.postMessage(branchDetails, '*');

        // Updated Drawing Tool Edit
        // Send this store's catalog so the drawing tool only offers products this site actually
        // sells (Type -> Style -> Height -> Color).  This replaces the legacy load-drawing / load-image messages.

        dtWindow.postMessage({
          type: 'afc:shopify:init',
          siteId: 'vinylworks',
          branding: { logoUrl: branchDetails.logo, footer: branchDetails.footer },
          catalog: CALCULATOR_FORM,
          // Per-product gate openings (handle -> [{ Key, Opening, ... }]) so the drawing tool offers
          // the gate sizes this store sells 
          // Keyed by CONFIG Name, same as the catalog  handle. Merge is safe: handles are disjoint across vinyl / chain-link / ornamental.
          gateOpenings: Object.assign(
            {},
            (typeof CHAIN_LINK_OPENINGS !== 'undefined' ? CHAIN_LINK_OPENINGS : {}),
            (typeof OI_OPENINGS !== 'undefined' ? OI_OPENINGS : {}),
            (typeof VINYL_OPENINGS !== 'undefined' ? VINYL_OPENINGS : {})
          ),
          // Gets the product the customer pre-selected on the store form (a CONFIG Name / handle). The tool opens its picker on this product. 
          selectedHandle: name,
          // Edit-from-cart: when re-opening a saved drawing, `data` is the prior drawing rawData, which the tool rehydrates so the customer edits in place.
          loadDrawing: data || null
        }, '*');

        window.removeEventListener('message', onReadyMessage);
      }
    }
    window.addEventListener('message', onReadyMessage);
  }

  // open the drawing tool window on button click
  $('#btn-start-drawing-tool').click(function () {
    openDrawingTool();
  });

  // open the drawing tool window on button click
  $('#btn-start-drawing-tool-popup-blocked').click(function () {
    window.location.search = "?edit-drawing=true&name=" + oldDrawingData.name + "&style=" + oldDrawingData.style + "&color=" + oldDrawingData.color;
  });

  function calculateDrawingTool(inventory, rawData) {
    if (inventory && inventory.length > 0) {
      var fence = inventory[0];
      console.log('Drawing Tool Fence', fence);

      // gets gates from customer submission
      woodGateSizes = inventory[0].Gates;

      var calc = $('#calc-dt');
      calc.empty();
      // add length inputs for calculator
      fence.Segments.forEach(s => {
        var footageInput = $('<input>').attr({
          class: 'footage-input',
          value: s.Length
        });
        calc.append(footageInput);
      });
      // add post inputs for calculator
      fence.Posts.forEach(p => {
        var typeLookup = {
          endpost: 'End',
          cornerpost: 'Corner',
          blankpost: 'Blank',
          gatepost: 'Gate'
        };

        var type = typeLookup[p.PostType];
        if (type) {
          var select = $('<select>').attr({
            class: 'term-post-input'
          });
          var option = $('<option>').attr({
            value: type,
            selected: 'selected'
          });
          select.append(option);
          calc.append(select);
        }
      });

      // get gate ids from gateConfig
      var gateIds = fence.Gates.map(g => {
        var type = 'Single';
        if (g.Description.match('double')) {
          type = 'Double';
        }
        var config = { Key: type, Opening: g.Length };

        var configSearch = gatesConfig.filter(c => c.Key == type && c.Opening == g.Length);
        if (configSearch.length > 0) {
          config = configSearch[0];
        }
        return config;
      }).filter(g => undefined != g && null != g);


      gateIds.forEach(g => {
        var select = $('<select>').attr({
          class: 'fg-input'
        });
        var option = $('<option>').attr({
          value: g.Key,
          selected: 'selected',
          'data-id': g.ID,
          'data-opening': g.Opening
        });

        select.append(option);
        calc.append(select);
      });

      //console.log(calc);
      window.usedDrawingTool = true;
      var drawingData = {
        inventory,
        rawData,
        name,
        color,
        drawing_image,
        style
      };
      if (typeof (Storage) !== "undefined") {
        window.sessionStorage.setItem('drawingData', JSON.stringify(drawingData));
      }
      calculate();
    }
  }

  window.addEventListener('message', function (message) {
    var inventory = message.data.inventory;
    var rawData = message.data.rawData;
    // getting draw my fence image from data
    drawing_image = message.data.drawingPath;
    console.log(":::::::::::::::::DRAWING IMAGE::::::::::::");
    console.log(drawing_image);
    console.log(message.data);

    // Updated Drawing Tool Edit
    // Returns the product the customer chose inside the tool. Treat it as the
    // source of truth.  product.handle is the CONFIG Name, product.style is the legacy style switched on by
    // calculate() / setGateConfig(). Re-resolve the product + gate config before calculating.
    if (message.data.product && message.data.product.handle) {
      name = message.data.product.handle;
      style = message.data.product.style;
      color = message.data.product.color;
      setProduct();
      setGateConfig();
    }

    calculateDrawingTool(inventory, rawData);
  });

  var oldCalculator = null;
  if (typeof (Storage) !== "undefined") {
    oldCalculator = sessionStorage.getItem("calculator");
  }

  var startTmpl = Handlebars.compile($("#startTmpl").html());
  console.log(oldCalculator);
  if (oldDrawingData && urlParams.has('edit-drawing')) {
    // show instructions
    $("#tool-selector").hide();
    //$("#example-drawing-tool").show();
    $("#edit-drawing-drawing-tool").show();
    $("#main-calculator").hide();
    // open the drawing tool and load the existing drawing
    openDrawingTool(oldDrawingData.rawData);
  }
  else if (oldCalculator) {

    $("#exampleInput").hide();
    $("#main-calculator").show();
    $("#formSection").hide();
    $("#startSection").show();
    $("#calcImg").show();

    setTimeout(function () {
      console.log("set values...");
      $("#calc-1").html(oldCalculator);
      var exist = $("section[class^='section-term-']").last();
      if (exist.length > 0) {
        var cls = $(exist).attr("class").replace("section-term-", "");
        termPostIdx = parseInt(cls);
      }
      $("html, body").animate({ scrollTop: 0 }, "slow");
      registerSelectHandlers();
      populateExample();
      $(".btn-add").click(addTermPost);
      $(".btn-remove").click(removeTermPost);
      $(".btn-calculate").click(calculate);
    }, 500);

  } else {
    var html = startTmpl({
      gates: gatesConfig,
    });
    $("#startSection").append(html)
    if (product) {
      $("#tool-selector").show();
      $("#about-dfm").hide();
      //$("#example").show();
      $("#main-calculator").hide();
    }
  }

  $('#btn-draw-fence').click(function () {
    $("#tool-selector").hide();
    $("#example-drawing-tool").show();
    $("#main-calculator").hide();
  });

  $('#btn-enter-fence').click(function () {
    $("#tool-selector").hide();
    $("#example").show();
    $("#main-calculator").hide();
  });

  var termPostTmpl = Handlebars.compile($("#termPostTmpl").html());
  var termPostTmplExample = Handlebars.compile($("#termPostTmplExample").html());
  var termPostIdx = 2;

  var exp = [
    { idx: 1, term: "Gate post", fence: "Single gate(4’ opening)", footage: "" },
    { idx: 2, term: "Gate post", fence: "Fence run", footage: "6" },
    { idx: 4, term: "Corner post", fence: "Fence run", footage: "60" },
    { idx: 5, term: "Corner post", fence: "Fence run", footage: "49" },
    { idx: 6, term: "Gate post", fence: "Double Gate(8’ opening)", footage: "" },
    { idx: 7, term: "Gate post", fence: "Fence run", footage: "44" },
    { idx: 8, term: "Corner post", fence: "Fence run", footage: "60" },
    { idx: 9, term: "Corner post", fence: "Fence run", footage: "12" },
    { idx: 10, term: "Gate post", fence: "Single gate(4’ opening)", footage: "" },
    { idx: 11, term: "Blank post", fence: "", footage: "" },
  ];

  function addTermPost(e) {
    var lastPost = $(".term-post-input[data-post='" + termPostIdx + "']").val();
    if (!lastPost) {
      lastPost = $(".select.term-post.term-post-input").last().val();
    }
    var fenceType = $(".fg-input[data-post='" + termPostIdx + "']").val();
    var isCorner = lastPost === "Corner";
    var isGate = lastPost === "Gate";

    if (!isCorner || !isGate) {
      termPostIdx++;
    } else {
      termPostIdx += 2
    }
    var idx2 = (isCorner || isGate) ? termPostIdx : (termPostIdx + 1);


    var html = termPostTmpl({
      idx: termPostIdx,
      idx2: idx2,
      isGate: isGate,
      notCorner: !isCorner,
      notGate: !isGate,
      gates: gatesConfig
    });


    $("#calc-1").append(html);
    registerSelectHandlers();
  }

  function removeTermPost(e) {
    if (termPostIdx == 2) {
      return;
    }
    $(".section-term-" + termPostIdx).remove();
    termPostIdx--;

    $(".section-term-" + termPostIdx).remove();
    termPostIdx--;

    registerSelectHandlers();
  }

  function populateExample() {
    exp.forEach(function (val) {
      var html = termPostTmplExample(val);
      $("#exampleInputShow").append(html);
    });
  }

  var locState = window.localStorage.getItem("step");
  if (!locState) {
    locState = 0;
  }
  if (locState >= 3) {
    locState = 0;
    window.localStorage.setItem("step", locState);
  }
  function showElem(val) {
    $("#example").hide();
    $("#exampleInput").hide();
    $("#main-calculator").hide();
    $(val).show();
  }

  $("#btnViewExample").click(function (e) {
    $("#example").hide();
    $("#exampleInput").show();

    locState++;
    window.localStorage.setItem("step", locState);
    window.history.pushState({ step: "1" }, "");

  });

  $("#btnStartCalculator").click(function (e) {
    $("#example").hide();
    $("#exampleInput").hide();
    $("#main-calculator").show();
    $("#formSection").hide();
    $("#startSection").show();
    $("#calcImg").show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    locState = 2;
    window.localStorage.setItem("step", locState);
    window.history.pushState({ step: "2" }, "");
    window.history.pushState({ step: "2" }, "");
  });

  $("#btnMyCalc").click(function (e) {
    $("#exampleInput").hide();
    $("#main-calculator").show();
    $("#formSection").hide();
    $("#startSection").show();
    $("#calcImg").show();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    locState++;
    window.localStorage.setItem("step", locState);
    window.history.pushState({ step: "2" }, "");

  });

  window.addEventListener('popstate', function (e) {
    switch (parseInt(window.localStorage.getItem("step"))) {
      case 1:
        showElem("#example");
        window.locState--;
        locState--;
        window.localStorage.setItem("step", locState);
        break;
      case 2:
        showElem("#exampleInput");
        locState--;
        window.localStorage.setItem("step", locState);
        break;
    }
  });

  function onSelectChange(e) {
    var post = $(this).data("post");
    var value = $(this, "option:selected").val();
    if (value === "Single" || value === "Double") {
      $(".post-" + post).prop("disabled", true);
      //$(".term-post[data-post='"+(parseInt(post)+1)+"']").val("Gate").prop('selected', true).trigger('change');
    } else {
      $(".post-" + post).prop("disabled", false);
    }
  }

  function registerSelectHandlers() {
    $(".fg-input").on('change', onSelectChange);
  }

  function calculate(e) {
    $("input,select,textarea").each(function () {
      if ($(this).is("[type='checkbox']") || $(this).is("[type='checkbox']")) {
        $(this).attr("checked", $(this).attr("checked"));
      } else if ($(this).is("select")) {
        $(this).find(":selected").attr("selected", "selected");
      } else {
        $(this).attr("value", $(this).val());
      }
    });
    console.log("style", style);
    if (typeof (Storage) !== "undefined") {
      sessionStorage.setItem("calculator", $("#calc-1").html());
    }
    switch (style) {
      case "vinyl":
        calculateVinly();
        break;
      case "chain-link":
        calculateChain();
        break;
      case "commercial-chain-link":
        calculateCommercialChain();
        break;
      case "ornamental-iron":
        if (product.Name.includes("-aluminum-")) {
          calculateOrnamentalAluminum();
        } else {
          calculateOrnamental();
        }
        break;
      case "wood":
        calculateWood();
        break;
    }
  }

  // --------------------------- CALCULATE WOOD --------------------------------

  function calculateWood() {

    //adds one extra post for termination
    var post = 1;
    var picket = 0;
    var rail = 0;
    //var totalIns = 0;
    //var oc = product.oc ? parseInt(product.oc) : 96;
    var oc = 96;

    // factoring posts and pickets for the length of fence minus any gate openings if present
    $(".footage-input").each(function (i, val) {
      var input = parseInt($(val).val());
      if (input) {
        //totalIns++;

        // factoring post count for each segment submitted
        post += Math.ceil(input * 12 / oc);

        // tmpPicket is the length for each segment submitted
        var tmpPicket = input;

        // selecting which formula to use for calculting pickets based on fence style
        if (name === "6-shadow-box-wood" || name === "4-shadow-box-wood-with-6-pickets" || name === "6-shadow-box-scalloped-wood" || name === "4-shadow-box-scalloped-wood") {
          picket += Math.ceil(tmpPicket * 2.89);
        }
        else if (name === "6-picket-wood-w-1-gap" || name === "4-picket-wood-fence" || name === "6-picket-scalloped-wood" || name === "4-picket-scalloped-wood") {
          picket += Math.ceil(tmpPicket * 12 / 6.5);
        }
        else {
          picket += Math.ceil(tmpPicket * 12 / 5.5);
        }
      }
    });

    var gate = $(".term-post-input :selected[value='Gate']").length;
    var extraRail = 0;

    // calculate parts when gates are submitted
    if (gate > 0) {
      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;
      var latch = 0;
      var hinge = 0;

      // loop through each submitted gate size to calculate needed pickets
      $.each(woodGateSizes, function (index, value) {
        var tmpPicket = value.Length;
        console.log("gate size: ", value.Length);
        console.log("starting picket ", picket);

        // factoring post count for each segment submitted
        post += Math.ceil(tmpPicket * 12 / oc);

        // selecting which formula to use for calculting gate pickets based on fence style
        if (name === "6-shadow-box-wood" || name === "4-shadow-box-wood-with-6-pickets" || name === "6-shadow-box-scalloped-wood" || name === "4-shadow-box-scalloped-wood") {
          picket += Math.ceil(tmpPicket * 2.89);
        }
        else if (name === "6-picket-wood-w-1-gap" || name === "4-picket-wood-fence" || name === "6-picket-scalloped-wood" || name === "4-picket-scalloped-wood") {
          picket += Math.ceil(tmpPicket * 12 / 6.5);
        }
        else {
          picket += Math.ceil(tmpPicket * 12 / 5.5);
        }
        console.log("ending picket ", picket);
      });

      // console.log("gate:" + gate +" single gate: " + single + "double gate: " + double);
      // console.log("single value: " + $(".fg-input :selected[value='Single']").val() );
      // return false;

      // assign latches, hinges and extra rails based on how many single gates submitted
      if (single) {
        latch += single;
        hinge += single;
        extraRail += 3 * single;
      }

      // assign latches, hinges and extra rails based on how many double gates submitted
      if (double) {
        latch += double;
        hinge += (double * 2);
        extraRail += 6 * double;
        // add needed droprod when double gate exits
        cart.push({ id: VARIANTSKU[0][product.DropRod], quantity: double });
      }
      if (latch) {
        cart.push({ id: VARIANTSKU[0][product.Latch], quantity: latch });
      }
      if (hinge) {
        cart.push({ id: VARIANTSKU[0][product.Hinge], quantity: hinge });
      }
    }

    console.log("post", post);
    cart.push({ id: VARIANTSKU[0][product.Post], quantity: post });

    // sets the waste variance to 5 percent due to cracked or bad pickets
    picket = picket + Math.ceil(picket * 0.05);
    console.log("picket", picket);
    cart.push({ id: VARIANTSKU[0][product.Picket], quantity: picket });

    // rails are based on posts, for every post we need either 2 or 3 rails based on Additional value in calculator_config
    // we deduct 1 post from rail math as we needed to add one for correct post count in include a termination post
    rail = Math.ceil((post - 1) * parseInt(product.Additional));
    rail = rail + extraRail;
    console.log("rail", rail);
    cart.push({ id: VARIANTSKU[0][product.Rail], quantity: rail });

    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }

  // --------------------------- CALCULATE ** COMMERCIAL ** CHAIN LINK -------------------------------------

  function calculateCommercialChain() {
    var line = 0;
    var total_input = 0;
    $(".footage-input").each(function (i, val) {
      var input = $(val).val();
      if (input) {
        input = parseInt(input);
        total_input += input;
        var l = input.toString().length;
        if (l == 2) {
          var j = Math.floor(input / 10);
          if (input % 10 == 0) {
            line += j - 1;
          } else {
            line += j;
          }
        } else if (l == 3) {
          var j = Math.floor(input / 10);
          line += j - 1;
        } else if (l == 1) {
          line += 0;
        } else {
          line += input;
        }
      }
    });
    console.log(line);

    // set End, Corner Post qty
    var corner = $(".term-post-input :selected[value='Corner']").length;
    var cornerbarb = $(".term-post-input :selected[value='Corner']").length;
    var cornerTensionWire = $(".term-post-input :selected[value='Corner']").length;
    console.log("corner", corner);
    var end = $(".term-post-input :selected[value='End']").length;
    var endbarb = $(".term-post-input :selected[value='End']").length;
    var endTensionWire = $(".term-post-input :selected[value='End']").length;
    console.log("end", end);
    var endCornerPostQTY = end + corner;

    var gate = $(".term-post-input :selected[value='Gate']").length;
    var gatebarb = $(".term-post-input :selected[value='Gate']").length;
    var gateTensionWire = $(".term-post-input :selected[value='Gate']").length;
    var forkLatchHanger = 0;

    if (gate > 0) {
      // cart.push({ id: product.EndCornerPost, quantity: gate });
      endCornerPostQTY = endCornerPostQTY + gate;
      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;
      var total = single + double;
      forkLatchHanger = total;

      // add fork latches & hangers
      if (product.CommercialForkLatch == undefined) {
        cart.push({ id: VARIANTSKU[0][product.ForkLatchHanger], quantity: total });
        cart.push({ id: VARIANTSKU[0][product.ForkLatch], quantity: total });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltLatchHanger], quantity: (total * 2) });
      }
      else {
        cart.push({ id: VARIANTSKU[0][product.CommercialForkLatch], quantity: total });
      }

      var maleHinge = 0;
      var femaleHinge = 0;
      var bulldoghinge = 0;
      if (single > 0) {
        //cart.push({id: product.SingleSwingGate, quantity: single});
        if (product.BullDogHinge == undefined) {
          maleHinge = 2 * single;
          femaleHinge = 2 * single;
          cart.push({ id: VARIANTSKU[0][product.MaleHinge], quantity: maleHinge });
          cart.push({ id: VARIANTSKU[0][product.FemaleHinge], quantity: femaleHinge });
        }
        else {
          bulldoghinge = 2 * single;
          cart.push({ id: VARIANTSKU[0][product.BullDogHinge], quantity: bulldoghinge });
        }
      }
      if (double > 0) {
        //cart.push({id: product.DoubleSwingGate, quantity: double});
        if (product.BullDogHinge == undefined) {
          maleHinge = 4 * double;
          femaleHinge = 4 * double;
          cart.push({ id: VARIANTSKU[0][product.MaleHinge], quantity: maleHinge });
          cart.push({ id: VARIANTSKU[0][product.FemaleHinge], quantity: femaleHinge });
        }
        else {
          bulldoghinge = 4 * double;
          cart.push({ id: VARIANTSKU[0][product.BullDogHinge], quantity: bulldoghinge });
        }
        // add drop rods
        cart.push({ id: VARIANTSKU[0][product.DropRod], quantity: double });
      }

      // add bolts for male / female hinges
      if (product.BullDogHinge == undefined) {
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltMaleHinge], quantity: maleHinge });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltFemaleHinge], quantity: femaleHinge });
      }
    }

    // add single gates to cart    
    $(".fg-input :selected[value='Single']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });

    // add double gates to cart
    $(".fg-input :selected[value='Double']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });

    // set number of tension bands needed per post
    var tension = 0;
    if (name.match("36")) {
      tension = 2;
    } else if (name.match("42") || name.match("48")) {
      tension = 3;
    } else if (name.match("60")) {
      tension = 4;
    } else if (name.match("72")) {
      tension = 5;
    } else if (name.match("84")) {
      tension = 6;
    } else if (name.match("96")) {
      tension = 7;
    } else if (name.match("120")) {
      tension = 9;
    } else if (name.match("144")) {
      tension = 11;
    }
    console.log("tension", tension);

    // add wire ties
    cart.push({ id: VARIANTSKU[0][product.WireTires], quantity: Math.ceil(total_input / 100) });

    // add end bands / brace bands
    if (product.BarbwireRoll == undefined) {
      var endbands = end + endTensionWire + gate + gateTensionWire + (corner * 2) + (cornerTensionWire * 2);
      console.log("endbands", endbands);
      cart.push({ id: VARIANTSKU[0][product.EndBand], quantity: endbands });
    }
    else {
      var endbands = end + (endbarb * 3) + endTensionWire + gate + (gatebarb * 3) + gateTensionWire + (corner * 2) + (cornerbarb * 6) + (cornerTensionWire * 2);
      console.log("endbands", endbands);
      cart.push({ id: VARIANTSKU[0][product.EndBand], quantity: endbands });
    }

    // add Rail ends
    var railends = end + (gate) + (corner * 2);
    console.log("railends", railends);
    cart.push({ id: VARIANTSKU[0][product.RailEnds], quantity: railends });

    // add Line Loop Tops - OR - Barbwire Arms
    if (product.BarbwireArm == undefined) {
      var lineTops = $(".term-post-input").length;
      console.log("lineTops", lineTops);
      if (line > 0) {
        cart.push({ id: VARIANTSKU[0][product.LineTop], quantity: line });
      }
    }
    else {
      if (line > 0) {
        cart.push({ id: VARIANTSKU[0][product.BarbwireArm], quantity: line });
      }
    }

    // add Barbwire
    if (product.BarbwireRoll != undefined) {
      var BarbwireQTY = Math.ceil((total_input * 3) / 1320);
      cart.push({ id: VARIANTSKU[0][product.BarbwireRoll], quantity: BarbwireQTY });
    }

    // add tension bands
    var tensionBands = ((gate) * tension) + (end * tension) + ((corner * tension) * 2);
    if (tension > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBand], quantity: tensionBands });
    }

    // factor how many bolts
    if (product.CommercialForkLatch == undefined) {
      var carriageBoltEndTension = endbands + tensionBands + (forkLatchHanger * 2);
    }
    else {
      var carriageBoltEndTension = endbands + tensionBands;
    }
    cart.push({ id: VARIANTSKU[0][product.CarriageBoltTensionBand], quantity: carriageBoltEndTension });

    // add Post Caps
    if (end > 0) {
      console.log("EndPostCap", end);
      cart.push({ id: VARIANTSKU[0][product.EndPostCap], quantity: end + corner + gate });
    }

    // add hog rings
    if (product.HogRings !== undefined) {
      var hogRingQTY = Math.ceil(total_input / 100);
      cart.push({ id: VARIANTSKU[0][product.HogRings], quantity: hogRingQTY });
    }

    // add tension wire
    if (product.TensionWire !== undefined) {
      if (name.toLowerCase().includes("black")) {
        var tensionWireFootage = 500;
      }
      else {
        var tensionWireFootage = 1000;
      }
      var tensionWireQTY = Math.ceil(total_input / tensionWireFootage);
      cart.push({ id: VARIANTSKU[0][product.TensionWire], quantity: tensionWireQTY });
    }

    // add tension bars
    if (railends > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBar], quantity: railends });
    } else if (endbands > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBar], quantity: endbands });
    }

    // add rail sleeve if needed
    if (product.RailSleeve !== undefined) {
      var railSleeveQTY = parseInt(Math.ceil(total_input / 21));
      cart.push({ id: VARIANTSKU[0][product.RailSleeve], quantity: railSleeveQTY });
    }

    // add top rail
    var topRail = parseInt(Math.ceil(total_input / 21));
    cart.push({ id: VARIANTSKU[0][product.TopRail], quantity: topRail });

    // add line posts
    if (line > 0) {
      cart.push({ id: VARIANTSKU[0][product.LinePost], quantity: line });
    }

    // add end corner post
    cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: endCornerPostQTY });

    // add fabric
    cart.push({ id: VARIANTSKU[0][product.Fabric], quantity: total_input });

    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }

  // --------------------------- CALCULATE ** RESIDENTIAL ** CHAIN LINK ---------------------------------------

  function calculateChain() {
    var line = 0;
    var total_input = 0;
    $(".footage-input").each(function (i, val) {
      var input = $(val).val();
      if (input) {
        input = parseInt(input);
        total_input += input;
        var l = input.toString().length;
        if (l == 2) {
          var j = Math.floor(input / 10);
          if (input % 10 == 0) {
            line += j - 1;
          } else {
            line += j;
          }
        } else if (l == 3) {
          var j = Math.floor(input / 10);
          line += j - 1;
        } else if (l == 1) {
          line += 0;
        } else {
          line += input;
        }
      }
    });
    console.log(line);

    // set End, Corner Post qty
    var corner = $(".term-post-input :selected[value='Corner']").length;
    console.log("corner", corner);
    var end = $(".term-post-input :selected[value='End']").length;
    console.log("end", end);
    var endCornerPostQTY = end + corner;

    var gate = $(".term-post-input :selected[value='Gate']").length;
    var forkLatchHanger = 0;

    if (gate > 0) {
      // cart.push({ id: product.EndCornerPost, quantity: gate });
      endCornerPostQTY = endCornerPostQTY + gate;
      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;
      var total = single + double;
      forkLatchHanger = total;

      // add fork latches & hangers
      cart.push({ id: VARIANTSKU[0][product.ForkLatchHanger], quantity: total });
      cart.push({ id: VARIANTSKU[0][product.ForkLatch], quantity: total });

      var maleHinge = 0;
      var femaleHinge = 0;
      if (single > 0) {
        //cart.push({id: product.SingleSwingGate, quantity: single});
        maleHinge = 2 * single;
        femaleHinge = 2 * single;
        cart.push({ id: VARIANTSKU[0][product.MaleHinge], quantity: maleHinge });
        cart.push({ id: VARIANTSKU[0][product.FemaleHinge], quantity: femaleHinge });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltMaleHinge], quantity: maleHinge });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltFemaleHinge], quantity: femaleHinge });
      }
      if (double > 0) {
        //cart.push({id: product.DoubleSwingGate, quantity: double});
        maleHinge = 4 * double;
        femaleHinge = 4 * double;
        cart.push({ id: VARIANTSKU[0][product.MaleHinge], quantity: maleHinge });
        cart.push({ id: VARIANTSKU[0][product.FemaleHinge], quantity: femaleHinge });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltMaleHinge], quantity: maleHinge });
        cart.push({ id: VARIANTSKU[0][product.CarriageBoltFemaleHinge], quantity: femaleHinge });

        // add drop rods
        cart.push({ id: VARIANTSKU[0][product.DropRod], quantity: double });
      }
    }

    // add single gates to cart    
    $(".fg-input :selected[value='Single']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });

    // add double gates to cart
    $(".fg-input :selected[value='Double']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });

    // set number of tension bands needed per post
    var tension = 0;
    if (name.match("42") || name.match("48")) {
      tension = 3;
    } else if (name.match("60")) {
      tension = 4;
    } else if (name.match("72")) {
      tension = 5;
    } else if (name.match("36")) {
      tension = 2;
    }
    console.log("tension", tension);

    // add wire ties
    cart.push({ id: VARIANTSKU[0][product.WireTires], quantity: Math.ceil(total_input / 100) });

    // add end bands
    var endbands = end + (gate) + (corner * 2);
    console.log("endbands", endbands);
    cart.push({ id: VARIANTSKU[0][product.EndBand], quantity: endbands });

    // add Rail ends
    var railends = end + (gate) + (corner * 2);
    console.log("railends", railends);
    cart.push({ id: VARIANTSKU[0][product.RailEnds], quantity: railends });

    // add Line Loop Tops
    var lineTops = $(".term-post-input").length;
    console.log("lineTops", lineTops);
    if (line > 0) {
      cart.push({ id: VARIANTSKU[0][product.LineTop], quantity: line });
    }

    // add tension bands
    var tensionBands = ((gate) * tension) + (end * tension) + ((corner * tension) * 2);
    if (tension > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBand], quantity: tensionBands });
    }

    // factor how many bolts
    var carriageBoltEndTension = endbands + tensionBands;
    cart.push({ id: VARIANTSKU[0][product.CarriageBoltTensionBand], quantity: carriageBoltEndTension });

    // add Post Caps
    if (end > 0) {
      console.log("EndPostCap", end);
      cart.push({ id: VARIANTSKU[0][product.EndPostCap], quantity: end + corner + gate });
    }

    // add tension bars
    if (railends > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBar], quantity: railends });
    } else if (endbands > 0) {
      cart.push({ id: VARIANTSKU[0][product.TensionBar], quantity: endbands });
    }

    // add top rail
    var topRail = parseInt(Math.ceil(total_input / 21));
    cart.push({ id: VARIANTSKU[0][product.TopRail], quantity: topRail });

    // add line posts
    if (line > 0) {
      cart.push({ id: VARIANTSKU[0][product.LinePost], quantity: line });
    }

    // add end corner post
    cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: endCornerPostQTY });

    // add fabric
    cart.push({ id: VARIANTSKU[0][product.Fabric], quantity: total_input });

    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }

  // ---------------------------- CALCULATE * STEEL * ORNAMENTAL ---------------------------------------------

  function calculateOrnamental() {
    var panel = 0;
    var line = 0;
    var combinedNonGatePosts = 0;
    var singleGatePost = 0;
    var doubleGatePost = 0;
    var combinedGatePost = 0;
    var combinedGatePostBracket = 0;
    var adjustPostForGate = 0;
    var hinge = 0;
    var latch = 0
    var droprod = 0;
    var oc = product.oc ? parseInt(product.oc) : 96.5;
    $(".footage-input").each(function (i, val) {
      var input = $(val).val();
      if (input) {
        var res = Math.ceil(parseInt($(val).val() * 12) / oc);
        panel += res;
        line += Math.floor(parseInt($(val).val() * 12) / oc);
      }
    });

    var corner = $(".term-post-input :selected[value='Corner']").length;
    console.log("corner", corner);

    var end = $(".term-post-input :selected[value='End']").length;
    console.log("end", end);

    var blank = $(".term-post-input :selected[value='Blank']").length;
    console.log("blank", blank);

    var gate = $(".term-post-input :selected[value='Gate']").length;
    console.log("gate", gate);

    if (gate > 0) {
      // if (product.GatePost) {
      //   cart.push({ id: VARIANTSKU[0][product.GatePost], quantity: gate });
      //   cart.push({ id: VARIANTSKU[0][product.GatePostCap], quantity: gate });
      // }
      // cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: gate })

      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;
      console.log("single", single);
      console.log("double", double);
      if (single > 0) {
        cart.push({ id: VARIANTSKU[0][product.ForkLatch], quantity: single });
        //cart.push({id: product.SingleSwingGate, quantity: single});
        for (var i = 0; i < single; i++) {
          hinge += 2;
          latch += 1;
        }
      }

      if (double > 0) {
        cart.push({ id: VARIANTSKU[0][product.ForkLatch], quantity: double });
        //cart.push({id: product.DoubleSwingGate, quantity: double});
        for (var i = 0; i < double; i++) {
          hinge += 4;
          latch += 1;
          droprod += 1;
        }
      }

      if (hinge > 0) {
        cart.push({ id: VARIANTSKU[0][product.MaleHinge], quantity: hinge });
        cart.push({ id: VARIANTSKU[0][product.FemaleHinge], quantity: hinge });

      }
      if (latch > 0) { cart.push({ id: VARIANTSKU[0][product.LatchHanger], quantity: latch }) };

      if (droprod > 0) { cart.push({ id: VARIANTSKU[0][product.DoubleSwingGateDropRod], quantity: droprod }) };

      // add single gates to cart    
      $(".fg-input :selected[value='Single']").each(function (i, val) {
        var id = $(val).data('id');
        if (!id) {
          return;
        } else {
          cart.push({ id: VARIANTSKU[0][id], quantity: val });
          // tally single gate posts
          singleGatePost += 1;
          adjustPostForGate += 1;
        }
      });

      // add double gates to cart
      $(".fg-input :selected[value='Double']").each(function (i, val) {
        var id = $(val).data('id');
        if (!id) {
          return;
        } else {
          cart.push({ id: VARIANTSKU[0][id], quantity: val });
          // tally double gate posts
          doubleGatePost += 2;
        }
      });

      combinedGatePost = (singleGatePost + doubleGatePost);
      combinedGatePostBracket = parseInt(combinedGatePost * product.BracketMultiply) / 2;

      cart.push({ id: VARIANTSKU[0][product.GateBracket], quantity: combinedGatePostBracket });
      cart.push({ id: VARIANTSKU[0][product.GatePostCap], quantity: combinedGatePost });
      cart.push({ id: VARIANTSKU[0][product.GatePost], quantity: combinedGatePost });
    }

    // add caps
    var capq = line - corner + blank + end + 1 + adjustPostForGate;
    console.log("capq", capq);
    if (capq > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerCap], quantity: capq }) };

    // add non gate posts
    combinedNonGatePosts = line - corner + blank + end + 1 + adjustPostForGate;
    if (combinedNonGatePosts > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: combinedNonGatePosts }) };

    // // add line posts
    // if (line > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: line }) };

    // // add blank posts
    // if (blank > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: blank }) };

    // // add end posts
    // if (end > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: end }) };

    // // add corner posts
    // if (corner > 0) {
    //   cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: corner })
    // };

    // add std brackets
    cart.push({ id: VARIANTSKU[0][product.FlatMountBracket], quantity: parseInt(panel * product.BracketMultiply) - combinedGatePostBracket });

    // add panels
    console.log("panel", panel);
    cart.push({ id: VARIANTSKU[0][product.Panel], quantity: panel });

    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }


  // ------------------------------------ CALCULATE * ALUMINUM * ORNAMENTAL ------------------------------------------

  function calculateOrnamentalAluminum() {
    var panel = 0;
    var line = 0;
    var tallyLine = 0;
    var tallyEnd = 0;
    var singleGatePost = 0;
    var doubleGatePost = 0;
    var combinedGatePost = 0;
    var adjustPostForGate = 0;
    var oc = product.oc ? parseInt(product.oc) : 72.5;

    $(".footage-input").each(function (i, val) {
      var input = $(val).val();
      if (input) {
        var res = Math.ceil(parseInt($(val).val() * 12) / oc);
        panel += res;
        line += Math.floor(parseInt($(val).val() * 12) / oc);
      }
    });

    var corner = $(".term-post-input :selected[value='Corner']").length;
    console.log("corner", corner);

    var end = $(".term-post-input :selected[value='End']").length;
    console.log("end", end);

    // var blank = $(".term-post-input :selected[value='Blank']").length;
    // console.log("blank", blank);
    // if (blank > 0) { cart.push({ id: VARIANTSKU[0][product.EndCornerPost], quantity: blank }) };

    var gate = $(".term-post-input :selected[value='Gate']").length;
    console.log("gate", gate);

    if (gate > 0) {

      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;
      console.log("single", single);
      console.log("double", double);
      // aluminum gates come with all hardware, latches, etc.

      // add single gates to cart    
      $(".fg-input :selected[value='Single']").each(function (i, val) {
        var id = $(val).data('id');
        if (!id) {
          return;
        } else {
          cart.push({ id: VARIANTSKU[0][id], quantity: val });
          singleGatePost += 1;
          adjustPostForGate += 1;
        }
      });

      // add double gates to cart
      $(".fg-input :selected[value='Double']").each(function (i, val) {
        var id = $(val).data('id');
        if (!id) {
          return;
        } else {
          cart.push({ id: VARIANTSKU[0][product.DoubleSwingGateDropRod], quantity: val });
          cart.push({ id: VARIANTSKU[0][id], quantity: val });
          doubleGatePost += 2;
        }
      });

      combinedGatePost = (singleGatePost + doubleGatePost);
      cart.push({ id: VARIANTSKU[0][product.GatePostCap], quantity: combinedGatePost });
      cart.push({ id: VARIANTSKU[0][product.GatePost], quantity: combinedGatePost });
    }

    console.log("line = " + line + " corner = " + corner + " end = " + end);
    tallyLine = line - corner - end;
    tallyEnd = end + adjustPostForGate;

    var capq = tallyLine + corner + tallyEnd;
    console.log("capq", capq);
    cart.push({ id: VARIANTSKU[0][product.EndCornerLineCap], quantity: capq });

    if (end > 0) { cart.push({ id: VARIANTSKU[0][product.EndPost], quantity: tallyEnd }) };

    if (corner > 0) {
      cart.push({ id: VARIANTSKU[0][product.CornerPost], quantity: corner })
    };

    console.log("line", line);
    if (line > 0) { cart.push({ id: VARIANTSKU[0][product.LinePost], quantity: tallyLine }); };

    console.log("panel", panel);
    cart.push({ id: VARIANTSKU[0][product.Panel], quantity: panel });


    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }

  // ----------------------------------------- CALCULATE VINYL ------------------------------------------------

  function calculateVinly() {

    var panel = 0;
    var line = 0;
    var hinge = 0;
    var latch = 0
    var droprod = 0;
    var oc = product.oc ? parseInt(product.oc) : 93.25;
    $(".footage-input").each(function (i, val) {
      var input = $(val).val();
      if (input) {
        var res = Math.ceil(parseInt($(val).val()) * 12 / oc);
        panel += res;
        line += Math.floor(parseInt($(val).val()) * 12 / oc);
      }
    });

    var corner = $(".term-post-input :selected[value='Corner']").length;
    console.log("corner", corner);

    var gate = $(".term-post-input :selected[value='Gate']").length;
    console.log("gate", gate);

    var end = $(".term-post-input :selected[value='End']").length;
    var maxEnd = end;
    if (gate > 0) {
      maxEnd = end + gate;

      var single = $(".fg-input :selected[value='Single']").length;
      var double = $(".fg-input :selected[value='Double']").length;

      console.log("single", single);
      console.log("double", double);
      if (single > 0) {
        cart.push({ id: VARIANTSKU[0][product.GatePostInsert], quantity: single });
        //cart.push({id: product.SingleSwingGate, quantity: single});
        for (var i = 0; i < single; i++) {
          hinge += 1;
          latch += 1;
        }
      }
      if (double > 0) {
        cart.push({ id: VARIANTSKU[0][product.GatePostInsert], quantity: double * 2 });
        //cart.push({id: product.DoubleSwingGate, quantity: double});
        for (var i = 0; i < double; i++) {
          hinge += 2;
          latch += 1;
          droprod += 1;
        }
      }
    }

    if (hinge > 0) { cart.push({ id: VARIANTSKU[0][product.Hinge], quantity: hinge }) };
    if (latch > 0) { cart.push({ id: VARIANTSKU[0][product.Latch], quantity: latch }) };
    if (droprod > 0) { cart.push({ id: VARIANTSKU[0][product.DropRod], quantity: droprod }) };
    if (blank > 0) { cart.push({ id: VARIANTSKU[0][product.BlankPost], quantity: blank }) };

    // add single gates to cart    
    $(".fg-input :selected[value='Single']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });

    // add double gates to cart
    $(".fg-input :selected[value='Double']").each(function (i, val) {
      var id = $(val).data('id');
      if (!id) {
        return;
      } else {
        cart.push({ id: VARIANTSKU[0][id], quantity: val });
      }
    });


    // var gatesIds = {};
    // var counter = 1;

    // $(".fg-input :selected[value='Single']").each(function (i, val) {
    //   var id = $(val).data('id');
    //   if (!id) {
    //     return;
    //   }
    //   gatesIds[id] = counter;
    //   counter++;
    // });
    // if (counter > 1) {
    //   $.each(gatesIds, function (a, b) {
    //     cart.push({ id: a, quantity: b });
    //   });
    // }

    // counter = 1;
    // gatesIds = {};
    // $(".fg-input :selected[value='Double']").each(function (i, val) {
    //   var id = $(val).data('id');
    //   if (!id) {
    //     return;
    //   }
    //   gatesIds[id] = counter;
    //   counter++;
    // });
    // if (counter > 1) {
    //   $.each(gatesIds, function (a, b) {
    //     cart.push({ id: a, quantity: b });
    //   });
    // }

    var blank = $(".term-post-input :selected[value='Blank']").length;
    console.log("blank", blank);
    var caps = line + corner + end + gate + blank;
    console.log("caps", caps);
    var glue = Math.ceil(caps / 16);
    console.log("glue", glue);

    if (glue > 0) { cart.push({ id: VARIANTSKU[0][product.Glue], quantity: glue }) };

    cart.push({ id: VARIANTSKU[0][product.Cap], quantity: caps });

    if (corner > 0) { cart.push({ id: VARIANTSKU[0][product.CornerPost], quantity: corner }) };

    console.log("line", line);
    cart.push({ id: VARIANTSKU[0][product.LinePost], quantity: line });

    console.log("end", end);
    if (end > 0) { cart.push({ id: VARIANTSKU[0][product.EndPost], quantity: maxEnd }) };

    console.log("panel", panel);
    cart.push({ id: VARIANTSKU[0][product.Panel], quantity: panel });

    $.LoadingOverlay("show");
    removeCart(function () {
      add(cart.shift());
    });
  }


  if (!oldCalculator) {
    registerSelectHandlers();
    populateExample();
    $(".btn-add").click(addTermPost);
    $(".btn-remove").click(removeTermPost);
    $(".btn-calculate").click(calculate);

  }

  function add(item) {

    if (sent_drawing_to_cart === 'false') {
      sent_drawing_to_cart = 'true';
      // Store data in sessionStorage
      sessionStorage.setItem('dmf_image', drawing_image);
    }

    Shopify.addItem(item.id, item.quantity, function (e) {
      if (cart.length > 0) {
        add(cart.shift());
      } else {

        addFenceDrawingToCart();
        // Remove a specific item
        sessionStorage.removeItem('dmf_image');
        // Clear all sessionStorage data
        // sessionStorage.clear();

        $.LoadingOverlay("hide");
        if (window.usedDrawingTool) {
          window.location = '/cart?_drawing=true';
        }
        else {
          window.location = '/cart';
        }
      }
    });
  }

  function removeCart(callback) {
    Shopify.clear(callback);
  }

  function addFenceDrawingToCart() {
    // adding the draw my fence image to the cart data attributes  

    // Retrieve data from sessionStorage
    let dmf_image_output = sessionStorage.getItem('dmf_image');

    // Check if the key exists
    if (dmf_image_output) {
      // Key exists, use the value
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { attributes: { "DMF-drawing-image": dmf_image_output } },
        dataType: 'json',
        success: function () {
          // none
        }
      });
    } else {
      // Key does not exist
      console.log('DFM Not Available');
    }
  }

  setTimeout(function () {
    $(".tooltip-corner-post").hover(function () {
      $(this).append('<span class="tooltiptext">Corner post</span>').hide().fadeIn(300);
    }, function () {
      $(this).find("span").remove();
    });

    $(".tooltip-gate-post").hover(function () {

      $(this).append('<span class="tooltiptext">Gate</span>').hide().fadeIn(300);;
    }, function () {
      $(this).find("span").remove();
    });

    $(".tooltip-run-post").hover(function () {
      $(this).append('<span class="tooltiptext">Fence run</span>').hide().fadeIn(300);;
    }, function () {
      $(this).find("span").remove();
    });

  }, 500);
})
